/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".unsaved-warning-modal{text-align:center}.unsaved-warning-modal .modal-icon{display:block;margin:auto;height:unset;width:unset;font-size:88px;color:orange}.unsaved-warning-modal p{margin-bottom:3rem}.unsaved-warning-modal .operate{margin-left:auto;margin-right:auto;color:#41abf3;cursor:pointer;padding:10px;width:50%;max-width:300px}.unsaved-warning-modal .operate.default{background:#41abf3;color:#fff;border-radius:5px}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/unsaved.warning.modal/unsaved.warning.modal.component.scss.ngstyle.js.pre-build-optimizer.js